import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import {
    bbDoesCustomerHaveAccessToSubscription,
    bbDoesCustomerHaveAccessToSubscriptionLevel, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbFindUserTagsByTagId, bbIsEntityAwaitingFirstScoreCycle,
    isCurrentUserMemberOf,
    showBBNotification
} from "../../util/bbHelpers";
import {Button, IconButton, Modal, Popper} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import BBIconCheck from "../../assets/bbCustomIcons/BBIconCheck";
import Widget from "../../components/prefabricated/Widget";
import {SUCCESS} from "../../constants/ActionTypes";
import {Backdrop, Card, Paper} from "@mui/material";
import {addTagForToursNew, addTagForToursTutorial} from "../../actions";
import CloseIcon from "@material-ui/icons/Close";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {indexOfTours} from "./indexOfTours";
import BBIconQuestionHandRequest from "../../assets/bbCustomIcons/BBIconQuestionHandRequest";



const ProductWalkThroughsAndTours = (props)=>{

    const {match, children, } = props;

    const {authUser, startProductTour, loadingStartProductTour, startProductTourError} = useSelector(({auth})=>auth);
    const {portfolios, entityInView, loadingPortfolios} = useSelector(({breachrisk}) => breachrisk);
    const {customers, customerInView, loadingCustomers} = useSelector(({customer})=> customer);

    const [arrowRef, setArrowRef] = React.useState(null);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    const customer = customers && customerInView && customers[customerInView] ? customers[customerInView] : null;

    const onboardingProgress = myEntity && myEntity.onboarding_progress;
    const ownershipVerified = onboardingProgress && onboardingProgress.verified_ownership ? onboardingProgress.verified_ownership : null;
    // const customerHasBRBiz =
    // const customerHasBRport =
    const customerHasBRScore = !bbIsEntityAwaitingFirstScoreCycle(myEntity);
    const brBizSubSelfManaged = customer && customer.BRBManagedByStripe;
    const brPortSubSelfManaged = customer && customer.BRPManagedByStripe;

    const isFreeSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 10);
    const isLiteSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 6);
    const isProSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 7);
    const isPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);

    const isPortfolioTrial = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 1, 1);
    const isPortfolioStarter = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 1, 2);
    const isPortfolioPro = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 1, 3);
    const isPortfolioPremium = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 1, 4);


    // console.log("looking at these elements of state-- startProductTour", startProductTour, "startProductTourError", startProductTourError, "loadingStartProductTour", loadingStartProductTour,
    // "isFreeSubcsription", isFreeSubscription, "isLiteSubscription", isLiteSubscription, "isPro", isProSubscription, "isPremium", isPremiumSubscription, "look at entity", myEntity,
    //     "isPortoflioTrial", isPortfolioTrial, "isPortfolioStarter", isPortfolioStarter, "isPortfolioPro", isPortfolioPro, "isportfolioPremium", isPortfolioPremium, "lets look at the whole index of tours to see what and if it updates with entities??,", indexOfTours, "can i return just the funciton ones?? trying portfolio reports", indexOfTours.BRfPortfolioTourReports, "and the scores one I tried earlier", indexOfTours.BRfPTourInsightsPro)

    const userIsManager = authUser
        && authUser.customers
        && Array.isArray(customers)
        && authUser.customers
            .find(x=> x.customer === customerInView)
        && authUser.customers
            .find(x=> x.customer === customerInView).manager

    const userFirstLogin = authUser
        && authUser.user
        && authUser.user.first_login;

    const userShowTutorial = authUser
        && authUser.user
        && authUser.user.show_tutorial;

    const isAdmin = isCurrentUserMemberOf(authUser,"admin");

    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();

    const userTourTagsNew = bbFindUserTagsByTagId(authUser, 62);
    const userTourTagsTutorial = bbFindUserTagsByTagId(authUser, 61);

    const userToursTagsNewForPage = userTourTagsNew
        && userTourTagsNew
            .filter((tag)=> tag.details === location.pathname);
    const userToursTagsTutorialForPage = userTourTagsTutorial
        && userTourTagsTutorial
            .filter((tag)=> tag.details === location.pathname);

    const hasHadTourForPage = userToursTagsNewForPage && userToursTagsTutorialForPage && (userToursTagsTutorialForPage.length > 0 || userToursTagsNewForPage.length > 0);

    const currentPageIsPortfolio = location && location.pathname && location.pathname.startsWith(`/board/BreachRisk/Portfolio`);

    // console.log("currentPageIsPortoflio", currentPageIsPortfolio, "current location.pathname", location.pathname)

    let tour;


    console.log("Using product walkthrough to look at customer", customer, "and at myEntity", myEntity);


    let toursArray;

    //if page is a reports page (business) or a details page(portfolio) and that entity is still awaiting a score, should return no tours
    //filter for if ownership is verified/does it matter if owernship is verified

    if((location.pathname.includes('Details') || location.pathname.includes('Reports'))
        && bbIsEntityAwaitingFirstScoreCycle(myEntity)){
        const toursForPage = null;
        toursArray = [];
    }else if((location.pathname.includes("Business") && !bbDoesCustomerHaveAccessToSubscription(customer, 2))
    || (location.pathname.includes("Portfolio") && !bbDoesCustomerHaveAccessToSubscription(customer, 1)) ){
        //if they don't have access to the subscription associated iwth the page, don't show tours
        toursArray = [];
    } else{
        const toursForPage = Object.values(indexOfTours) && Object.values(indexOfTours)
            .filter((tour)=> location.pathname === tour.url);

        if(!ownershipVerified && !currentPageIsPortfolio){
            //selects only tours intended for business pages that don't have ownership verified yet
            toursArray = toursForPage.filter((tour)=> tour.entity && !tour.entity.verified_ownership)
        } else if(ownershipVerified && !currentPageIsPortfolio){
            //seleccts only tours intended for business pages that do have ownership verified
            toursArray = toursForPage.filter((tour)=> tour.entity && tour.entity.verified_ownership)
        } else{
            //ownershipverfied is only relevant if they have business subscription
            toursArray = toursForPage
        }
    }

    const filterToursForSubscriptionLevel = (pageToursArr, subLevelString)=>{
       return pageToursArr.filter((tour)=> tour.entity
            && tour.entity.subLevel
            && tour.entity.subLevel.includes(subLevelString));
    }

// console.log("What is toursArray before decided between tour or new ", toursArray)
//if it needs to be a tutorial walktrhough for the page
    if(userFirstLogin || userShowTutorial || startProductTour === location.pathname){
        if((startProductTour !== location.pathname)
            && hasHadTourForPage
            && userToursTagsTutorialForPage.length > 0){
            tour = null;
        } else {
            let tutorialToursForPage = toursArray.filter((tour)=> tour.type === "tutorial");
            console.log("tutorialToursForPage", tutorialToursForPage);

            const hasAccessToReports = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", entityInView);
            const hasAccessToTechDetails = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);

            if(currentPageIsPortfolio){
                if(location.pathname.includes("Reports") && hasAccessToReports){
                    tutorialToursForPage = tutorialToursForPage.filter((tour)=> tour.entity && tour.entity.hasReportsAccess)
                }else if (location.pathname.includes("Reports") && !hasAccessToReports){
                    tutorialToursForPage = tutorialToursForPage.filter((tour)=> (tour.entity && !tour.entity.hasReportsAccess) || (tour.entity && tour.entity.hasReportsAccess == null));
                }else if (location.pathname.includes("TechData") && hasAccessToTechDetails){
                    tutorialToursForPage = tutorialToursForPage.filter((tour)=> tour.entity && tour.entity.hasTechDataAccess)
                }else if(location.pathname.includes("TechData") && !hasAccessToTechDetails){
                    tutorialToursForPage = tutorialToursForPage.filter((tour)=> (tour.entity && !tour.entity.hasTechDataAccess) || (tour.entity && tour.entity.hasTechDataAccess == null));
                }

                let tourForPortfolioSubLevel;
                if(isPortfolioPremium){
                    tourForPortfolioSubLevel  = filterToursForSubscriptionLevel(tutorialToursForPage, "portfolioPremium");
                } else if (isPortfolioPro){
                    tourForPortfolioSubLevel  = filterToursForSubscriptionLevel(tutorialToursForPage, "portfolioPro");
                }else if (isPortfolioStarter){
                     tourForPortfolioSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "portfolioStarter")
                }else if(isPortfolioTrial){
                     tourForPortfolioSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "portfolioTrial");
                }else{
                    console.warn("Uncertain what product walkthrough to display. on a portoflio page, but not identified as having any subscription level type")
                }

                //portfolios will probably have to be checked again for access levels?
                tour = Array.isArray(tourForPortfolioSubLevel) && tourForPortfolioSubLevel.length > 0
                    ? tourForPortfolioSubLevel.find((tour => tour.entity && (tour.entity.hasScores === null || tour.entity.hasScores === true)))
                    : tutorialToursForPage.find((tour) => tour.entity && (tour.entity.hasScores === null || tour.entity.hasScores === true))

            } else{
                let tourForBusinessSubLevel;

                if(isPremiumSubscription){
                    tourForBusinessSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "premium");
                } else if (isProSubscription){
                    tourForBusinessSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "pro")
                } else if (isLiteSubscription){
                    tourForBusinessSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "lite");
                }else if(isFreeSubscription){
                    tourForBusinessSubLevel = filterToursForSubscriptionLevel(tutorialToursForPage, "free");
                }else{
                    console.warn("Uncertain what business subsceiption level is relevant for product walk through")
                }

                tour = Array.isArray(tourForBusinessSubLevel) && tourForBusinessSubLevel.length > 0
                             ? tourForBusinessSubLevel.find((tour => tour.entity && (tour.entity.hasScores === null || tour.entity.hasScores === true)))
                             : tutorialToursForPage.find((tour) => tour.entity && (tour.entity.hasScores === null || tour.entity.hasScores === true))

            }
        }
    } else if(!userFirstLogin && !userShowTutorial){
        //or else it's a "new" product walkthrough
        if(hasHadTourForPage
            && userToursTagsNewForPage.length > 0){
            tour = null;

        } else{
            tour = toursArray.find((tour)=> tour.type === "new")

        }
    }

    // console.log("hasHadTourFOrPage", hasHadTourForPage, "userToursTagsNewforPage", userToursTagsNewForPage, "userTourTagsNew", userTourTagsNew,"userTourTagsTutorial", userTourTagsTutorial, "tour", tour, "indexOfTours", indexOfTours, "ownershipVerified", ownershipVerified, "userFirstLogin",userFirstLogin, "userShowTutorial", userShowTutorial)

    const openingModal = tour
        && tour.openingModal;


    const tourSteps = tour && tour.tourSteps;

    // const tourStyleObject = tour && tour.style;

    const tourStyleObject = {
        // position: 'absolute',
        // top: '50%',
        // left: '5%',
        transform: 'translateX(240px) translateY(60px)',
        textColor: "#FEFEFE",
        opacity: '90%',
        // width: 400,
        // height: 250,
        background: '#326a8c',
        borderRadius: "0",
        // border: '1px solid #000',
        // boxShadow: "36px",
        p: 4,
        // zIndex: 1502,
        // zIndex: "50",
        // border:'1px solid #030852',
        // maxHeight: "150px",
        // width: "75%",
        zIndex: "1300",
    }

    const [modalOpen, setModalOpen] = useState(true);
    const [open, setOpen] = useState(false);
    const [step, setStep] = useState(null);
    const [openFreeSubModal, setOpenFreeSubModal] = useState(false);
    let anchorEl;

   useEffect(()=>{
       if(step && tourSteps && tourSteps[step] && tourSteps[step].element){
           // console.log("tour element attempt", tourSteps[step].element)
           tourSteps[step].element && [...tourSteps[step].element].map( elem=>
               elem.style.backgroundColor = "unset"
           )
       }
       setModalOpen(true);
       setOpen(false);
       setStep(null);
       // tour = null;
   }, [location.pathname, hasHadTourForPage]);

    if(step && tourSteps && tourSteps[step]){
        anchorEl = document.querySelector(tourSteps[step].anchorEl);
        if(tourSteps[step].scrollToElement === null || tourSteps[step].scrollToElement === undefined){
            console.log(" scrollToElement equals null, anchorEl should be scrolled to", anchorEl )
            //if there's not scrollToElement for step set, scroll to the anchor element; default behavior
            anchorEl && anchorEl.scrollIntoView({behavior: "smooth", block: "start", inline: "end"});
        }else if(tourSteps[step].scrollToElement !== null && tourSteps[step].scrollToElement !== false){
            //if there is somethign set, scroll to it
            console.log("scroll to element is not null and is not false", tourSteps[step].scrollToElement)
            const scrollToElement = document.querySelector(tourSteps[step].scrollToElement);
            scrollToElement && scrollToElement.scrollIntoView({behavior: "smooth", block: "start", inline: "end"})
        }else if (tourSteps[step].scrollToElement === false){
            console.log("scroll to Element is set to false, should stay still")
            //if it's set to false, dont move things, so ... nothing?
        }
    }

    if(step && tourSteps && tourSteps[step] && tourSteps[step].element){
        console.log("tour element attempt", tourSteps[step].element)
        tourSteps[step].element && [...tourSteps[step].element].map( elem=>
            elem.style.backgroundColor = "#E0D268"
        )
    }

    const handleClose = () =>{
        setModalOpen(false);
        // setOpen(false)
        // setStep(null);
        if(openFreeSubModal){
            setOpenFreeSubModal(false)
        }
        if(tour.type === "tutorial"){
            dispatch(addTagForToursTutorial(authUser.user.id, location.pathname))
        } else if (tour.type === "new"){
            dispatch(addTagForToursNew(authUser.user.id, location.pathname))
        }
    }


    const handleOpenSubscriptionsPage = () => {
        setOpenFreeSubModal(false)
        if(tour.type === "tutorial"){
            dispatch(addTagForToursTutorial(authUser.user.id, location.pathname))
            history.push(`/board/settings/subscription#manageSubscription`)
        } else if (tour.type === "new"){
            dispatch(addTagForToursNew(authUser.user.id, location.pathname))
            history.push(`/board/settings/subscription#manageSubscription`)

        }
    }

    const launchTour = () =>{
        setModalOpen(false);
        setOpen(true);
        setStep(1);

    }

    const handleNext = () => {


        if(tourSteps[step].last){
            setOpen(false)
            setStep(null);
            if(isFreeSubscription && !(isPremiumSubscription || isProSubscription || isLiteSubscription) && !currentPageIsPortfolio){
                setOpenFreeSubModal(true)
            }else{
                if(tour.type === "tutorial"){
                    dispatch(addTagForToursTutorial(authUser.user.id, location.pathname));
                } else if (tour.type === "new"){
                    dispatch(addTagForToursNew(authUser.user.id, location.pathname));
                }
            }


        } else{
            setStep(step + 1);
            if(step && tourSteps && tourSteps[step] && tourSteps[step].element){
                // console.log("tour element attempt", tourSteps[step].element)
                tourSteps[step].element && [...tourSteps[step].element].map( elem=>
                    elem.style.backgroundColor = "unset"
                )
            }
            //looking to trigger an event if the tour step calls for it
            if(step && tourSteps && tourSteps[step] && tourSteps[step].action){
                // tourSteps[step].action(tourSteps[step].value ? tourSteps[step].value : null);
                tourSteps[step].action()
                console.log("Attempting to make action/events happen with tours")
            }
            // history.replace(tourSteps[step].anchorEl)
        }
    }

    const handleBack = () => {

        if(step !== 1){
            setStep(step - 1);
        }

        if(step && tourSteps && tourSteps[step] && tourSteps[step].element){
            // console.log("tour element attempt", tourSteps[step].element)
            tourSteps[step].element && [...tourSteps[step].element].map( elem=>
                elem.style.backgroundColor = "unset"
            )
        }


    }

    // if(anchorEl && step){
    //     // anchorEl.style.backgroundColor="yellow"
    //     // anchorEl.style.filter = "brightness(125%)";
    //     // anchorEl.style.zIndex = 1502;
    //     // anchorEl.style["z-index"] = 1502;
    //
    // }

    openingModal && console.log("openingModal", openingModal)

   tourSteps && step && tourSteps[step] && console.log("tour", tour, "tourArray", toursArray,"step", step, "anchorEl", anchorEl, "tourSteps", tourSteps, "tourSteps[step[,", tourSteps[step], "step.anchorEl", tourSteps[step].anchorEl, "document.querSelectoretc", document.querySelector(tourSteps[step].anchorEl));

    if(!openingModal && tour && !step){
        launchTour();
    }

    if(myEntity && tour){
        return(
                <>
                    {openingModal &&
                        // <Modal open={modalOpen}
                               // style={{ maxHeight: "150px",
                               //     width: "75%",
                               //     zIndex: "1300",
                               // }}
                        // >
                         <Popper open={modalOpen}
                                // anchorEl={document.querySelector("#appBarNavBar")}
                                 className={"animation animation-delay-5 animation-duration-10 fadeIn"}
                                placement={"top"}
                                transition
                                popperOptions={{
                                    modifiers: {
                                        offset: {
                                            // offset: '-5,0',
                                        },
                                    },
                                }}
                                style={{ maxHeight: "150px",
                                    width: "calc(100% - 240px)",
                                    zIndex: "1300",
                                }}
                        >
                        <div style={tourStyleObject} className={"text-center text-white p-2 m-2 animation-delay-5 animation-duration-10 fadeIn"}>
                            <Row className={"text-right m-0 p-0"}>
                                <Col className={"m-0 p-0"}>
                                    <IconButton
                                        onClick={handleClose}
                                        className={"m-0 p-0"}
                                    >
                                        <CloseIcon className={"close text-white"}/>
                                    </IconButton>
                                </Col>
                            </Row>

                            {openingModal.icon
                                ? <Row className={"text-center"}>
                                    <Col>
                                        <h1>{openingModal.icon}</h1>
                                    </Col>
                                </Row>
                                :null}
                            {openingModal.heading
                                ?<Row  className={"mx-1 mt-2 px-1 pt-2 text-center"}>
                                    <Col>
                                        <h1>{openingModal.heading}</h1>
                                    </Col>
                                </Row>
                            : null}
                            {openingModal.description
                                ?<Row className={"m-2 px-2"}>
                                    <Col>
                                        <p>{openingModal.description}</p>
                                    </Col>
                                </Row>
                                :null}
                            <Row className={"m-2 px-2"}>
                                <Col>
                                    <p>
                                        Press Start Tour to start this tour, or Skip Tour to skip it. You can access this tour at any
                                        time, by clicking &nbsp; <BBIconQuestionHandRequest/> &nbsp; in the right hand corner.
                                    </p>
                                </Col>
                            </Row>
                            <Row className={"mb-3 my-2 p-2"}>
                                <Col className={"text-right"}>
                                    <Button variant={"contained"}
                                            onClick={launchTour}
                                            className={"d-inline bg-secondary text-white"}
                                    >
                                        Start Tour
                                    </Button>&nbsp;
                                    <Button variant={"contained"}
                                            onClick={handleClose}
                                            className={"d-inline bg-secondary text-white"}
                                    >
                                        Skip Tour
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                         </Popper>
                    // </Modal>
    }

                    { step && tourSteps && anchorEl && <div>
                        {/*<Backdrop*/}
                        {/*    sx={{ color: '#fff', zIndex: "1000"}}*/}
                        {/*    open={open}*/}
                        {/*>*/}
                        <Popper open={open}
                                anchorEl={anchorEl}
                                placement={tourSteps[step] && tourSteps[step].placement ? tourSteps[step].placement : "top-start"}
                                transition
                                style={{ maxWidth: "500px",
                                        zIndex: "1300",
                                }}
                                modifiers={{
                                    name: 'arrow',
                                    enabled: true,
                                    options: {
                                        element: arrowRef,
                                    },
                                }}
                        >
                            {/*//TODO: figure out how to add the pointer in*/}
                            <span id={"arrow"} ref={setArrowRef} />
                            <Card className={"text-center p-2 m-2 bg-primary text-white animation-duration-10 fadeIn"}
                                   elevation={24}
                                    style={{minHeight: "100px", zIndex: "50", border:'1px solid #030852', borderRadius: "0", opacity: "90%"  }}>
                                    {/*<span className={classes.arrow} ref={setArrowRef} />*/}
                                <div>
                                    <Row className={"text-right m-0 p-0"}>
                                        <Col className={"m-0 p-0"}>
                                            <IconButton
                                                onClick={handleClose}
                                                className={"m-0 p-0 "}
                                            >
                                                <CloseIcon className={"close text-white"}/>
                                            </IconButton>
                                        </Col>
                                    </Row>
                                    {tourSteps[step].title
                                        ?<Row className={"my-1 py-1"}>
                                        <Col>
                                            <h2 className={"text-center"}>
                                                {tourSteps[step].title}
                                            </h2>
                                        </Col>
                                    </Row>
                                    : null}
                                    <Row className={"mx-2 px-2 my-1 py-1"}>
                                        <Col>
                                            {tourSteps[step].content ? tourSteps[step].content : " "}
                                        </Col>
                                    </Row>
                                    <Row className={"text-right"}>
                                        <Col sm={1} lg={1}> </Col>
                                        {step !== 1 &&
                                            <Col>
                                                <Button onClick={handleBack}
                                                        variant={"contained"}
                                                        className={"bg-secondary text-white float-left"}
                                                >Back</Button>
                                            </Col>}
                                        {step === 1 && !openingModal &&
                                            <Col>
                                                <Button onClick={handleClose}
                                                        variant={"contained"}
                                                        className={"bg-secondary text-white float-left"}
                                                >Skip Tour</Button>
                                            </Col>
                                        }
                                        <Col>

                                            <Button onClick={handleNext}
                                                    variant={"contained"}
                                                    className={"bg-secondary text-white float-right"}
                                            >{tourSteps[step].last && !isFreeSubscription ? "End" : "Next"}</Button>
                                        </Col>
                                        <Col sm={1} lg={1}> </Col>
                                    </Row>
                                </div>
                            </Card>
                        </Popper>
                        {/*</Backdrop>*/}
                    </div>}

                    {openFreeSubModal &&
                        <Popper open={openFreeSubModal}
                            // anchorEl={document.querySelector("#appBarNavBar")}
                                className={"animation animation-delay-5 animation-duration-10 fadeIn"}
                                placement={"top"}
                                transition
                                popperOptions={{
                                    modifiers: {
                                        offset: {
                                            // offset: '-5,0',
                                        },
                                    },
                                }}
                                style={{ maxHeight: "150px",
                                    width: "calc(100% - 240px)",
                                    zIndex: "1300",
                                }}>
                            <div style={tourStyleObject} className={"text-center p-2 m-2 bg-lighter-gray animation-duration-10 fadeIn"}>
                                <Row className={"text-right m-0 p-0"}>
                                    <Col className={"m-0 p-0"}>
                                        <IconButton
                                            onClick={handleClose}
                                            className={"m-0 p-0"}
                                        >
                                            <CloseIcon className={"close text-white"}/>
                                        </IconButton>
                                    </Col>
                                </Row>
                                <Row  className={"mx-1 mt-2 px-1 pt-2 text-center"}>
                                    <Col>
                                        <h1>Upgrade Your Subscription</h1>
                                    </Col>
                                </Row>
                                <Row className={"m-2 p-2"}>
                                    <Col>
                                        <p>Get the most out of BreachRisk&trade; by upgrading your subscription.</p>

                                          <strong> <p> Start any subscription now and get a two week free trial.</p></strong>
                                    </Col>
                                </Row>

                                <Row className={"mb-3 my-2 p-2"}>
                                    <Col className={"text-right"}>
                                        <Button variant={"contained"}
                                                onClick={handleOpenSubscriptionsPage}
                                                className={"d-inline bg-secondary text-white"}
                                        >
                                            Manage Subscriptions
                                        </Button>&nbsp;
                                        <Button variant={"contained"}
                                                onClick={handleClose}
                                                className={"d-inline bg-secondary text-white"}
                                        >
                                            Close
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Popper>

                    }

                    {children}
            </>
        )
    }

    return(
        <>
            {children}
        </>
    )
}

export default ProductWalkThroughsAndTours;